import React from 'react';
import HeroSlider from '../HeroSlider/HeroSlider.js';
import News from '../News/News.jsx';
import SEOHelmet from '../SEO/SEOHelmet.jsx';
import { useTranslation } from 'react-i18next';
// import AI4Good from '../../components/AI4Good/AI4Good';
// import CookieManager from '../CookieConsent/CookieConsent.jsx'
// import Marquee from '../Marquee/marquee.jsx';
// import SvgMapComponent from '../GBA/svgmap.jsx';

const HomePage = () => {
  const { i18n } = useTranslation();
  
const seoData = {
    en: {
        title: 'DRONE.COM.HK - Leveraging Drone Technology for a Smarter City',
        description: 'DRONE.COM.HK integrates drone technology to create smarter cities by revolutionizing education, entertainment, urban planning, emergency response, and logistics. Explore innovations, applications, and the Low-altitude economy.',
        keywords: 'Drone Technology, Smart Cities, AI Hub, Hong Kong, STEAM Learning, Urban Planning, Emergency Response, AI Logistics, Low-altitude economy, AI for Good'
    },
    'zh-HK': {
        title: 'DRONE.COM.HK - 運用無人機技術打造智慧城市',
        description: 'DRONE.COM.HK 整合無人機技術，通過變革教育、娛樂、城市規劃、緊急應變和物流，打造更智慧的城市。探索創新應用和低空經濟的未來。',
        keywords: '無人機技術, 智慧城市, 香港AI中心, STEAM學習, 城市規劃, 緊急應變, AI物流, 低空經濟, AI造福社會'
    },
    'zh-CN': {
        title: 'DRONE.COM.HK - 运用无人机技术打造智慧城市',
        description: 'DRONE.COM.HK 整合无人机技术，通过变革教育、娱乐、城市规划、紧急应对和物流，打造更智慧的城市。探索创新应用和低空经济的未来。',
        keywords: '无人机技术, 智慧城市, 香港AI中心, STEAM学习, 城市规划, 紧急应对, AI物流, 低空经济, AI造福社会'
    }
};
  
  const currentLang = i18n.language || 'en';
  const currentSEO = seoData[currentLang] || seoData.en;
  
  return (
    <>
      <SEOHelmet
        title={currentSEO.title}
        description={currentSEO.description}
        keywords={currentSEO.keywords}
        url="/"
        type="website"
        image="/HK_1920x1080.jpg"
      />
      
      <main>
        <section id="hero" aria-label="Hero Section">
          <HeroSlider />
        </section>
        
        <section id="news" aria-label="Latest News">
          <News />
        </section>
        
        {/* Future sections can be added here */}
        {/* <section id="solutions" aria-label="AI Solutions">
          <Marquee />
          <SvgMapComponent />
        </section> */}
      </main>
    </>
  );
};

export default HomePage;